const Navigation = [
  {
    title: 'Home',
    url: '/',
  },
];

export default Navigation;
